import Typography from '@mui/material/Typography';
import CollapsibleFrame from '../../components/CollapsibleFrame';
import { CollapsibleTable } from "../../components/CollapsibleTable";
import { MainContainer } from "../../components/MainContainerComp";
import ScrollIndicatorsComp from '../../components/ScrollIndicatorsComp/ScrollIndicatorsComp';
import { CurrentCapabilitiesDataAutomation, DroppedCapabilitiesDataAutomation, ICapabilitiesData, ICapabilityItem, ICapabiltity } from './CapabilitiesData';
import { collapsibleFrameStyles, tableHeaderStyles } from "./styled";

export const Capabilities = ({
  data: { currentCapabilitiesCount, droppedCapabilitiesCount, currentCapabilities, droppedCapabilities } }:
  { data: ICapabilitiesData }
) => {
  const getCapabilities = (isCurrent = true) => {
    const data = isCurrent ? currentCapabilities : droppedCapabilities;
    return data ? data.map(({ description, capabilities }: ICapabilityItem) =>
    ({
      title: description,
      capabilties: capabilities.map(({ description, effectiveDate, droppedDate }: ICapabiltity, i: number) =>
      ({
        description: isCurrent || (!isCurrent && i === 0) ? description : '',
        effectiveDate,
        droppedDate
      })),
      capability: 'Capability',
      effectiveDate: 'Effective Date',
      droppedDate: 'Dropped Date',
    })) : []
  }

  return (
    <MainContainer hasGreyBg>
      <CollapsibleFrame
        openByDefault
        sx={collapsibleFrameStyles}
        title={
          <Typography
            sx={tableHeaderStyles}
            data-automation="current-capabilities-header"
          >
            Current Capabilities Held ({currentCapabilitiesCount})
          </Typography>
        }
      >
        <Typography 
          component={'div'} 
          variant='container' 
          data-automation="data-container"
        >
          <ScrollIndicatorsComp>
            <CollapsibleTable
              size="custom"
              isThreeLevel={true}
              rows={getCapabilities()}
              dataAutomation={CurrentCapabilitiesDataAutomation}
            />
          </ScrollIndicatorsComp>
        </Typography>
      </CollapsibleFrame>
      <CollapsibleFrame
        openByDefault
        sx={collapsibleFrameStyles}
        title={
          <Typography
            sx={tableHeaderStyles}
            data-automation="dropped-capabilities-header"
          >
            Dropped Capabilities ({droppedCapabilitiesCount})
          </Typography>
        }
      >
        <Typography 
          component={'div'} 
          variant='container' 
          data-automation="data-container"
        >
          <ScrollIndicatorsComp>
            <CollapsibleTable
              size="custom"
              isThreeLevel={true}
              rows={getCapabilities(false)}
              dataAutomation={DroppedCapabilitiesDataAutomation}
            />
          </ScrollIndicatorsComp>
        </Typography>
      </CollapsibleFrame>
    </MainContainer>
  )
}